module.exports = __webpack_public_path__ + "static/media/hh_vis_ir_comp.dd70e254.jpg";